/**
 * 更新翻译请求体
 */
export interface UpdateTranslationRequest {
    /**
     * 原始片段索引
     */
    original_index: number;
    /**
     * 目标文本
     */
    translation_text: string;
    /**
     * 任务ID
     */
    task_id: string;
}

export type UpdateTranslationResponse = void;

/**
 * 更新翻译请求
 */
export interface UpdateTranslationApi {
    /**
     * 更新翻译
     * @param request 更新翻译请求
     */
    updateTranslation(request: UpdateTranslationRequest): Promise<UpdateTranslationResponse>;
}

export const UpdateTranslationApi = Symbol('UpdateTranslationApi');
